export const TOGGLE_PROFILE_FOLLOW_REQUEST = 'TOGGLE_PROFILE_FOLLOW_REQUEST';
export const TOGGLE_PROFILE_FOLLOW_SUCCESS = 'TOGGLE_PROFILE_FOLLOW_SUCCESS';
export const TOGGLE_PROFILE_FOLLOW_FAILURE = 'TOGGLE_PROFILE_FOLLOW_FAILURE';
export const RESET_TOGGLE_PROFILE_FOLLOW = 'RESET_TOGGLE_PROFILE_FOLLOW';

export const UPDATE_FOLLOW_STATE_TO_STORE_USER = 'UPDATE_FOLLOW_STATE_TO_STORE_USER';